function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0L32 0 32 32 0 32z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#9E9E9E",
  d: "M10.667 21.333h10.666V24H10.667v-2.667zm0-5.333h10.666v2.667H10.667V16zm8-13.333H8c-1.467 0-2.667 1.2-2.667 2.666v21.334c0 1.466 1.187 2.666 2.654 2.666H24c1.467 0 2.667-1.2 2.667-2.666v-16l-8-8zm5.333 24H8V5.333h9.333V12H24v14.667z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M0 0L16 0 16 16 0 16z",
  transform: "translate(16 16)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#9E9E9E",
  d: "M8 .667C3.945.667.667 3.945.667 8S3.945 15.333 8 15.333 15.333 12.055 15.333 8 12.055.667 8 .667z",
  transform: "translate(16 16)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M11.333 10.393L10.393 11.333 8 8.94 5.607 11.333 4.667 10.393 7.06 8 4.667 5.607 5.607 4.667 8 7.06 10.393 4.667 11.333 5.607 8.94 8z",
  transform: "translate(16 16)"
})));

var SvgIcFailToLoad = function SvgIcFailToLoad(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcFailToLoad, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic-fail-to-load.c10ddc2e.svg";
export { ForwardRef as ReactComponent };